import classNames from 'classnames/bind';
import { useContext } from 'react';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';

import styles from './ModalOverLay.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { AnimatePresence, motion } from 'framer-motion';

const cx = classNames.bind(styles);

function ModalOverLay() {
  const { modalComponentContent, setModalComponentContent } = useContext(ModalOverLayContext);
  const handleHide = () => {
    setModalComponentContent(null);
  };

  return (
    <AnimatePresence>
      {modalComponentContent && (
        <div className={cx('wrapper')}>
          <div className={cx('overlay')} onClick={handleHide}></div>
          <motion.div className={cx('content')}
            initial={{opacity: 0, y: 30 , scale: 0.8}}
            animate={{opacity: 1, y: 0 , scale: 1}}
            exit={{opacity: 0, y: 30 , scale: 0.8}}
          >
            <FontAwesomeIcon className={cx('icon')} icon={faXmark} onClick={handleHide} />
            {modalComponentContent}
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );

  return (
    <div className={cx('wrapper', { show: modalComponentContent })}>
      <div className={cx('overlay')} onClick={handleHide}></div>
      <div className={cx('content')}>
        <FontAwesomeIcon className={cx('icon')} icon={faXmark} onClick={handleHide} />
        {modalComponentContent}
      </div>
    </div>
  );
}

export default ModalOverLay;
